import { useState, useEffect } from "react";

import { ReservationThreadData, Reservation } from "../types/reservation";

export const useThreads = (
  reservation: Reservation | undefined,
  threadUid: string | undefined
) => {
  const [threads, setThreads] = useState<ReservationThreadData[]>([]);

  useEffect(() => {
    if (reservation && threadUid) {
      const thread = reservation?.reservationMessageThreads?.find(
        (t) => t.uid === threadUid
      );
      setThreads(thread ? [thread] : []);
    }
  }, [reservation, threadUid]);

  return { threads, setThreads };
};
